import { Link } from 'react-router-dom';

import ChevronRightIcon from '../../icons/chevron-right';

import './styles/list-row.css';

export default function ListRow({ to, eyebrow, title, meta, trailing, tone, children }) {
    const classes = ['list-row', tone && `list-row--${tone}`].filter(Boolean).join(' ');
    const body = (
        <>
            <span className="list-row__main">
                {eyebrow && <span className="list-row__eyebrow">{eyebrow}</span>}
                <span className="list-row__title">{title}</span>
                {meta && <span className="list-row__meta">{meta}</span>}
                {children}
            </span>
            {trailing && <span className="list-row__trailing">{trailing}</span>}
            {to && <ChevronRightIcon className="list-row__chevron" size={18} />}
        </>
    );
    return (
        <li className="list-row__item">
            {to ? <Link to={to} className={classes}>{body}</Link> : <div className={classes}>{body}</div>}
        </li>
    );
}
